import nodeApi from '../utils/nodeApiClient';
import UnifiedConfig from '../config/unified';

const proformaInvoicesApi = {
  list: (params) => nodeApi.get('/proforma-invoices', { params }),
  create: (data) => nodeApi.post('/proforma-invoices', data),
  updateTaxInvoice: (id, taxInvoiceNo, taxReceivedAmt) =>
    nodeApi.put(`/proforma-invoices/${id}`, { tax_invoice_no: taxInvoiceNo, tax_received_amt: taxReceivedAmt }),
  updateGeneral: (id, bcId, invDate) =>
    nodeApi.put(`/proforma-invoices/${id}`, { bc_id: bcId, inv_date: invDate }),
  remove: (id) => nodeApi.delete(`/proforma-invoices/${id}`),

  getDetails: (id) => nodeApi.get(`/proforma-invoices/${id}/details`),
  getDropdownContacts: () => nodeApi.get('/proforma-invoices/dropdowns/contacts'),
  getDropdownSaleOrders: (contactId) => nodeApi.get('/proforma-invoices/dropdowns/sale-orders', { params: { contact_id: contactId } }),

  sendView: (id, data) => nodeApi.post(`/proforma-invoices/${id}/send-view`, data, { timeout: 60000 }),
  getPdfDownloadUrl: async (id) => {
    const base = await UnifiedConfig.getNodeApiBaseUrl();
    return `${base}/proforma-invoices/${id}/pdf`;
  }
};

export default proformaInvoicesApi;
